export default __webpack_public_path__ + "static/media/home_nonhealthcare_steps.84831c64.webp";